import React from "react";
import { useTranslation } from 'react-i18next';

const Articles = () =>{
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    
    return(
        <div id='keyfigures'>
            <div className="container mt-5 article-1" style={{paddingBottom:"100px"}}>
                <h2 className={`${isArabic ? 'notokufi-bold' : 'avenir-heavy'} key-figures`}>{t('articles.title')}</h2>
                <div className="row mt-5">
                <div className="col-md-6">
                        <div className="row mb-2" style={{ position: "relative" }}>
                          <img className="rtl-image" src="../assets/images/card-1.png"/>
                          <div className="art-card-2 rtl-art-card" style={{ position: "absolute", top: "15%",paddingLeft:"50px"}}>
                                <h1 className={`${isArabic ? 'notokufi-black' : 'avenir-black'}`} style={{ color: "#FD7C1A" }}>87%</h1>
                                <h4 className={`text-light pt-3 ${isArabic ? 'notokufi-black' : 'avenir-black'}`}>{t('articles.card-1-title')}</h4>
                                <p className={`pt-2 ${isArabic ? 'notokufi-regular' : 'avenir-regular'} text-light`} style={{fontSize:"0.8em ",width:"40%"}}>
                                {t('articles.card-1-desc')}
                                </p>
                          </div>
                        </div>
                        <div className="row mb-2" style={{ position: "relative" }}>
                          <img className="rtl-image" src="../assets/images/card-2.png"/>
                          <div className="art-card-2 rtl-art-card" style={{ position: "absolute", top: "15%",paddingLeft:"50px"}}>
                                <h1 className={`${isArabic ? 'notokufi-black' : 'avenir-black'}`} style={{ color: "#FD7C1A" }}>64%</h1>
                                <h4 className={`text-light pt-3 ${isArabic ? 'notokufi-black' : 'avenir-black'}`} >{t('articles.card-2-title')}</h4>
                                <p className={`pt-2 ${isArabic ? 'notokufi-regular' : 'avenir-regular'} text-light`} style={{fontSize:"0.8em ",width:"40%"}}>
                                 {t('articles.card-2-desc')}
                                </p>
                          </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row mb-2" style={{ position: "relative" }}>
                          <img className="rtl-image" src="../assets/images/card-3.png"/>
                          <div className="art-card-2 rtl-art-card" style={{ position: "absolute", top: "15%",paddingLeft:"50px"}}>
                                <h1 className={`${isArabic ? 'notokufi-black' : 'avenir-black'}`} style={{ color: "#FD7C1A" }}>72%</h1>
                                <h4 className={`text-light pt-3 ${isArabic ? 'notokufi-black' : 'avenir-black'}`}>{t('articles.card-3-title')}</h4>
                                <p className={`pt-2 ${isArabic ? 'notokufi-regular' : 'avenir-regular'} text-light`} style={{fontSize:"0.8em ",width:"40%"}}>
                                {t('articles.card-2-desc')}
                                </p>
                          </div>
                        </div>
                        <div className="row mb-2" style={{ position: "relative" }}>
                          <img className="rtl-image" src="../assets/images/card-4.png"/>
                          <div className="art-card-2 rtl-art-card" style={{ position: "absolute", top: "15%",paddingLeft:"50px"}}>
                                <h1 className={`${isArabic ? 'notokufi-black' : 'avenir-black'}`} style={{ color: "#FD7C1A" }}>80%</h1>
                                <h4 className={`text-light pt-3 ${isArabic ? 'notokufi-black' : 'avenir-black'}`}>{t('articles.card-4-title')}</h4>
                                <p className={`pt-2 ${isArabic ? 'notokufi-regular' : 'avenir-regular'} text-light`} style={{fontSize:"0.8em ",color:"#909090",width:"40%"}}>
                                {t('articles.card-4-desc')}
                                </p>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Articles;